import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Toast } from 'vant'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 50000
})
console.log(JSON.stringify(process.env.VUE_APP_BASE_API))
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 如果有token，添加到请求头
    const token = store.state.token
    if (token) {
      config.headers['u-token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.config.responseType == 'stream') {
      return response
    }
    const res = response.data
    if (res.retCode == 0 || res.code == '00000') {
      return res
    } else if (res.code === '10000') {
      // 未登录
      let redirect = router.currentRoute.query.redirect
      redirect = redirect || router.currentRoute.fullPath
      Toast.fail('登录已过期，请重新登录')
      router.push({
        path: '/login',
        query: {
          redirect
        }
      })
    } else {
      Toast.fail(res.retMsg)
      return Promise.reject(res.retMsg || '请求失败')
    }
  },
  error => {
    console.log('掉接口失败', error)
    Toast.fail('网络错误，请稍后重试')
    return Promise.reject(error)
  }
)

export default service
